import { jsx } from "react/jsx-runtime";
import { styled, Dialog as Dialog$1 } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import { sizeStyles } from "./utils.js";
import { useState, useLayoutEffect } from "react";
const MODAL_TOP_BOTTOM_MARGIN = 48, DIALOG_BODY_CLASSNAME = ".MuiPaper-root", useHandleContentOverflowY = () => {
  const [modalContainer, setModalContainer] = useState(
    null
  );
  return useLayoutEffect(() => {
    if (!modalContainer) return;
    const resized = () => {
      const paper2 = modalContainer.querySelector(
        DIALOG_BODY_CLASSNAME
      );
      if (!(paper2 != null && paper2.parentElement)) return;
      const { height } = paper2.getBoundingClientRect();
      height + MODAL_TOP_BOTTOM_MARGIN * 2 > window.innerHeight ? paper2.parentElement.style.alignItems = "start" : paper2.parentElement.style.alignItems = "center";
    }, resizeObserver = new ResizeObserver(resized), paper = modalContainer.querySelector(
      DIALOG_BODY_CLASSNAME
    );
    if (paper)
      return resizeObserver.observe(modalContainer), resizeObserver.observe(paper), () => {
        resizeObserver.disconnect();
      };
  }, [modalContainer]), { setModalContainer };
}, Dialog = styled(
  ({ maxWidth: _, ...props }) => {
    const { setModalContainer } = useHandleContentOverflowY();
    return /* @__PURE__ */ jsx(
      Dialog$1,
      {
        ref: setModalContainer,
        "data-test-id": DATA_TEST_ID_INHERITED,
        keepMounted: !1,
        ...props
      }
    );
  },
  shouldNotForwardProps(["size", "maxWidth", "fullFrameMobile"])
)(({ theme: t, maxWidth, fullFrameMobile, size = "md" }) => ({
  borderRadius: 0,
  ".MuiDialog-container": {
    overflowY: "auto",
    alignItems: "start"
  },
  ".MuiPaper-root": {
    overflowY: "initial",
    maxHeight: "initial",
    boxShadow: "none",
    borderRadius: 0,
    color: "inherit",
    margin: 0,
    [t.breakpoints.up("sm")]: {
      marginTop: MODAL_TOP_BOTTOM_MARGIN,
      marginBottom: MODAL_TOP_BOTTOM_MARGIN
    },
    [t.breakpoints.only("xs")]: {
      marginTop: fullFrameMobile ? 0 : MODAL_TOP_BOTTOM_MARGIN,
      marginBottom: fullFrameMobile ? 0 : MODAL_TOP_BOTTOM_MARGIN,
      width: "100%!important",
      marginLeft: 16,
      marginRight: 16
    },
    "&.MuiDialog-paperFullWidth": {
      width: "96%",
      maxWidth: maxWidth ?? "initial"
    },
    ...sizeStyles(t, size, fullFrameMobile)
  }
}));
Dialog.displayName = "Dialog";
export {
  DIALOG_BODY_CLASSNAME,
  Dialog,
  MODAL_TOP_BOTTOM_MARGIN
};
//# sourceMappingURL=Dialog.js.map
